import React from 'react';

const features = [
  {
    id: 1,
    image: '/org/future/product_m05.png',
    title: 'Wi-Fiでコンテンツ配信',
    description: '直観性に優れた専用管理画面(IOS/Androidスマホアプリ・Webブラウザ)からコンテンツをネット配信',
  },
  {
    id: 2,
    image: '/org/future/product_m07.png',
    title: '電源1本だけのシンプル配線',
    description: '現場スタッフの負担を軽減しコスト削減にもつながります。',
  },
  {
    id: 3,
    image: '/org/future/product_m03.png',
    title: 'オールインワンソリューション',
    description: '高性能なスケジュール管理機能を搭載しています。',
  },
  {
    id: 4,
    image: '/org/future/product_m04.png',
    title: 'インテリジェントビデオウォール',
    description: 'モニターサイズと位置に合わせてコンテンツのサイズや配置を自動調整',
  },
  {
    id: 5,
    image: '/org/future/product_m06.png',
    title: '複数拠点を一括遠隔管理',
    description: 'ビデオウォールの作成からスケジュール設定、コンテンツの配信まですべてを遠隔地から一括操作',
  },
  {
    id: 6,
    image: '/org/future/product_m08.png',
    title: '簡単設置',
    description: '壁にブラケットを取り付けるモニターを掛けるだけ。設置とメンテナンスコストが抑えられます',
  },
];

export const FeaturesSection: React.FC = () => {
  return (
    <section id="features" className="features">
      <div className="container">
        <h2 className="section-title">WiCanvasの特長</h2>
        <div className="features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="feature-card">
              <div className="feature-icon">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="feature-image"
                />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
